// Wybór dokładnych kolorów (pole 16, gałąź „Mam firmowe kolory").
//
// Każdy wiersz to para: natywny <input type="color"> jako próbka do klikania
// i pole tekstowe na kod HEX. Dwie drogi do tej samej wartości — klient
// z gotowym kodem z brandbooka wpisuje go z palców, klient bez kodu klika
// próbkę. Synchronizacja idzie w obie strony.
//
// Wartość leci do ukrytego pola jako "#aabbcc, #ddeeff" (draft i FormData
// widzą zwykły input tekstowy).

import { announce } from "./a11y.js";

const START_COLOR = "#1d3557";

const SVG_X =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

// Przyjmujemy „1d3557", „#1D3557" i skrót „#1d3" — zwracamy #rrggbb albo "".
function normalizeHex(raw) {
    let hex = (raw || "").trim().replace(/^#/, "").toLowerCase();
    if (/^[0-9a-f]{3}$/.test(hex)) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    return /^[0-9a-f]{6}$/.test(hex) ? "#" + hex : "";
}

export function initColors(form) {
    form.querySelectorAll("[data-color-picker]").forEach((container) => {
        const list = container.querySelector(".brief__colorsList");
        const addBtn = container.querySelector("[data-color-add]");
        const hidden = container.querySelector('input[type="hidden"]');
        const max = Number(container.dataset.max || 4);
        if (!list || !addBtn || !hidden) return;

        function sync() {
            const hexes = Array.from(list.querySelectorAll('input[type="color"]')).map(
                (input) => input.value
            );
            hidden.value = hexes.join(", ");
            addBtn.hidden = hexes.length >= max;
            // powiadom resztę (draft, walidacja required_unless) o zmianie —
            // zwykłe pole zrobiłoby to samo
            hidden.dispatchEvent(new Event("input", { bubbles: true }));
        }

        function renumber() {
            Array.from(list.children).forEach((row, index) => {
                const swatch = row.querySelector('input[type="color"]');
                const hex = row.querySelector(".brief__colorsHex");
                const remove = row.querySelector(".brief__colorsRemove");
                if (swatch) swatch.setAttribute("aria-label", "Kolor " + (index + 1) + " — próbnik");
                if (hex) hex.setAttribute("aria-label", "Kolor " + (index + 1) + " — kod HEX");
                if (remove) remove.setAttribute("aria-label", "Usuń kolor " + (index + 1));
            });
        }

        function addRow(value) {
            const start = normalizeHex(value) || START_COLOR;

            const row = document.createElement("span");
            row.className = "brief__colorsItem";

            const swatch = document.createElement("input");
            swatch.type = "color";
            swatch.className = "brief__colorsSwatch";
            swatch.value = start;

            const hex = document.createElement("input");
            hex.type = "text";
            hex.className = "brief__colorsHex";
            hex.value = start.toUpperCase();
            hex.maxLength = 7;
            hex.spellcheck = false;
            hex.autocapitalize = "off";
            hex.autocomplete = "off";
            hex.placeholder = "#1D3557";

            swatch.addEventListener("input", () => {
                hex.value = swatch.value.toUpperCase();
                hex.classList.remove("is-bad");
                sync();
            });

            hex.addEventListener("input", () => {
                const normalized = normalizeHex(hex.value);
                if (normalized) {
                    swatch.value = normalized;
                    hex.classList.remove("is-bad");
                    sync();
                }
            });

            // porządkujemy dopiero przy wyjściu z pola — poprawianie kodu
            // w trakcie pisania wyrywałoby kursor
            hex.addEventListener("blur", () => {
                const normalized = normalizeHex(hex.value);
                if (normalized) {
                    hex.value = normalized.toUpperCase();
                    hex.classList.remove("is-bad");
                } else if (hex.value.trim() !== "") {
                    hex.classList.add("is-bad");
                } else {
                    hex.value = swatch.value.toUpperCase();
                    hex.classList.remove("is-bad");
                }
                sync();
            });

            const remove = document.createElement("button");
            remove.type = "button";
            remove.className = "brief__colorsRemove";
            remove.innerHTML = SVG_X;
            remove.addEventListener("click", () => {
                row.remove();
                renumber();
                sync();
                announce("Kolor usunięty.");
            });

            row.append(swatch, hex, remove);
            list.appendChild(row);
            renumber();
        }

        addBtn.addEventListener("click", () => {
            if (list.children.length >= max) return;
            addRow();
            sync();
            const added = list.lastElementChild.querySelector('input[type="color"]');
            if (added) added.focus();
        });

        // odtworzenie wierszy ze szkicu (init po restore draftu)
        const saved = (hidden.value || "")
            .split(",")
            .map((hex) => normalizeHex(hex))
            .filter(Boolean);
        saved.slice(0, max).forEach(addRow);
        addBtn.hidden = saved.length >= max;
    });
}
